import React, {useMemo} from "react";
import {
    Container,
} from 'reactstrap'
import { useTranslation } from "react-i18next";
import { Switch, Route, useRouteMatch, Redirect } from "react-router-dom";

import MainLayout from '../layouts/MainLayout'
import ContractsTableContainer from '../containers/ContractsTable';
import IncomingContractsTableContainer from '../containers/IncomingContractsTable';
import { PageHeader } from '../components/PageHeader'


function ContractList() {
    const { t } = useTranslation();
    const { path, url } = useRouteMatch();
    console.log({url})

    const tabs = useMemo(() => {
        return [
            {
                id: 1,
                path: `${url}/own`,
                label: t('myDocuments')
            },
            {
                id: 2,
                path: `${url}/inbox`,
                label: t('inbox')
            },
        ]
    }, [t, url])

    return (
        <MainLayout className="">
            <PageHeader className="bg-white pb-0 pt-4">
                    <PageHeader.Title>{t('contracts')}</PageHeader.Title>
                    <PageHeader.Tabs tabs={tabs} />
            </PageHeader>
            <Container className="p-3">
                <Switch>
                    <Route path={`${path}/own`}>
                        <ContractsTableContainer className="rounded" />
                    </Route>
                    <Route path={`${path}/inbox`}>
                        <IncomingContractsTableContainer className="rounded" />
                    </Route>
                    <Redirect from={path} to={`${path}/own`} />
                </Switch>
            </Container>
        </MainLayout>
    );
}

export default ContractList;
